<template>
  <b-modal centered hide-header no-close-on-backdrop hide-footer :id="id">
    <div class="modal-content-wrapper">
      <div class="close-icon" @click="closeModal">
        <img src="@/assets/icon/close.svg" />
      </div>
      <div v-if="title" class="title">{{ title }}</div>
      <slot></slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['id', 'title'],
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';
.modal-content-wrapper {
  position: relative;
  .close-icon {
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .title {
    font-size: 26px;
    font-weight: 600;
    color: #203a54;
    text-align: center;
    padding: 24px 0;
    font-family: Inter;
  }
}
::v-deep #purchase-modal {
  .modal-dialog {
    .modal-content {
      box-shadow: 0px 4px 32px rgba(52, 87, 210, 0.12);
      border-radius: 16px;
    }
  }
}
::v-deep #make-offer-modal {
  .modal-dialog {
    .modal-content {
      box-shadow: 0px 4px 32px rgba(52, 87, 210, 0.12);
      border-radius: 16px;
    }
  }
}
::v-deep #abort-selling-modal {
  .modal-dialog {
    .modal-content {
      box-shadow: 0px 4px 32px rgba(52, 87, 210, 0.12);
      border-radius: 16px;
    }
  }
}
::v-deep #confirm-acception-modal {
  .modal-dialog {
    .modal-content {
      box-shadow: 0px 4px 32px rgba(52, 87, 210, 0.12);
      border-radius: 16px;
    }
  }
}
@media screen and (max-width: $breakpoint-mobile) {
}
</style>
